// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"6476cfa0","314":"c13232ba","351":"85c91d6f","580":"995943d7","701":"af4f7373","715":"5be454ea"}[chunkId] + ".css";
};